module.exports = __webpack_public_path__ + "assets/4-Tech-Talent-Scouts.e4883341.png";